import { render } from "./AdminLogIn.vue?vue&type=template&id=48362826&ts=true"
import script from "./AdminLogIn.vue?vue&type=script&lang=ts"
export * from "./AdminLogIn.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__